import {createContext, RefObject, useContext} from 'react';

import {noop} from 'shared/web';

export interface Section {
  title: string;
  ref: RefObject<HTMLDivElement | null>;
}

export const NavigationContext = createContext<{
  sections: Section[];
  registerSection: (title: string) => RefObject<HTMLDivElement | null>;
  activeSection: number;
}>({
  sections: [],
  registerSection: noop,
  activeSection: 0,
});

export const useNavigation = () => useContext(NavigationContext);
